/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import Container from "@/src/components/Container/Container";
import AlertContentLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertContentLegalbird";
import AlertLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertLegalbird";
import { Box } from "@mui/material";

const EmailConfirmationBox = () => {
  const { customer } = useCustomer();

  if (customer === null || customer.verification !== null) {
    return null;
  }

  return (
    <Container variant={"sm"}>
      <AlertLegalbird severity={"warning"}>
        <AlertContentLegalbird
          title={"Bitte bestätigen Sie Ihre E-Mail-Adresse!"}
          description={
            <>
              Klicken Sie hierzu auf den Link in der E-Mail, die wir Ihnen an{" "}
              <Box component="span" sx={{ wordBreak: "break-all" }} id="hintbox-email">
                {customer?.email}
              </Box>{" "}
              geschickt haben. Schauen Sie hierzu ggf. auch in Ihren SPAM-Ordner. Wenn Sie Ihre E-Mail bestätigt haben, können Sie alle Funktionen der
              Servicewelt nutzen.
            </>
          }
        />
      </AlertLegalbird>
    </Container>
  );
};

export default EmailConfirmationBox;
